import { languages, SurveyText } from "./SurveyText";

export class SurveyItemQuery {
  constructor(
    public type: ItemTypes,
    public id: string,
    public displayName: string[][],
    public ruleRequired: string,
    public ruleMax: string,
    public options: string[][],
    public units: string[][],
    public unitsRules: string
  ) {}
}

export class OptionTextArea {
  constructor(public id: string, public text: string) {}
}

export class RadioItemValue {
  constructor(
    public selected: string,
    public optionTextArea?: OptionTextArea
  ) {}
}

export class CheckBoxItemValue {
  constructor(
    public selected: string[],
    public optionTextArea?: OptionTextArea[]
  ) {}
}

export class Option {
  constructor(
    public id: string,
    public value: SurveyText[],
    public isTextArea: boolean
  ) {}
}

export type ItemTypes =
  | "st"
  | "em"
  | "rd"
  | "cb"
  | "dt"
  | "sl"
  | "ta"
  | "cs"
  | "nb"
  | "error";

export class SurveyItem {
  constructor(
    public type: ItemTypes,
    public id: string,
    public displayName: SurveyText[],
    public value: string | RadioItemValue | CheckBoxItemValue,
    public options: Option[],
    public units: SurveyText[],
    public unitsRules: boolean,
    public rules: { required: boolean; max: number }
  ) {}

  static initSurveyItemsValue(surveyItems: SurveyItem[]) {
    return surveyItems.map(v => {
      switch (v.type) {
        case "rd":
          v.value = new RadioItemValue("");
          break;
        case "cb":
          v.value = new CheckBoxItemValue([]);
          break;
        default:
          v.value = "";
          break;
      }
      return v;
    });
  }

  static getInstances(cols: SurveyItemQuery[]) {
    if (cols == null) {
      return [];
    }
    return cols.map(SurveyItem.getInstance).filter(v => v.type != "error");
  }

  static getInstance(col: SurveyItemQuery) {
    if (
      col.type == "st" ||
      col.type == "em" ||
      col.type == "dt" ||
      col.type == "ta" ||
      col.type == "cs"
    ) {
      return new SurveyItem(
        col.type,
        col.id,
        col.displayName.map(v => new SurveyText(v[0] as languages, v[1])),
        "",
        [],
        [],
        col.unitsRules == "r",
        {
          required: col.ruleRequired == "r",
          max: parseInt(col.ruleMax)
        }
      );
    } else if (col.type == "rd" || col.type == "cb" || col.type == "sl") {
      let value: string | RadioItemValue | CheckBoxItemValue;
      switch (col.type) {
        case "rd":
          value = new RadioItemValue("");
          break;
        case "cb":
          value = new CheckBoxItemValue([]);
          break;
        default:
          value = "";
          break;
      }
      return new SurveyItem(
        col.type,
        col.id,
        col.displayName.map(v => new SurveyText(v[0] as languages, v[1])),
        value,
        col.options.map((opt, idx) => {
          const required = opt[opt.length - 1] === "r" ? true : false;
          const values = opt
            .filter((_, i) => i < opt.length - 1)
            .map(v => new SurveyText(v[0] as languages, v[1]));
          return new Option(String(idx + 1), values, required);
        }),
        [],
        col.unitsRules == "r",
        {
          required: col.ruleRequired == "r",
          max: parseInt(col.ruleMax)
        }
      );
    } else if (col.type == "nb") {
      return new SurveyItem(
        col.type,
        col.id,
        col.displayName.map(v => new SurveyText(v[0] as languages, v[1])),
        "",
        [],
        col.units.map(v => new SurveyText(v[0] as languages, v[1])),
        col.unitsRules == "r",
        {
          required: col.ruleRequired == "r",
          max: parseInt(col.ruleMax)
        }
      );
    } else {
      return new SurveyItem("error", "", [], "", [], [], false, {
        required: col.ruleRequired == "r",
        max: parseInt(col.ruleMax)
      });
    }
  }
}
